import React, { useEffect, useState } from 'react';
import { API_URL } from '../utils/graphConfig';
import './WatchList.css';

/**
 * Volatility early-warning watch-list: currently-calm names the model flags as
 * most likely to see elevated volatility over the next ~5 days. Per asset type.
 */
export const WatchList = ({ assetType, setSelectedTickers }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let active = true;
    setLoading(true);
    fetch(`${API_URL}/early_warning?asset_type=${assetType}&limit=12`)
      .then((r) => r.json())
      .then((d) => { if (active) { setItems(Array.isArray(d) ? d : []); setLoading(false); } })
      .catch(() => { if (active) { setItems([]); setLoading(false); } });
    return () => { active = false; };
  }, [assetType]);

  const isForex = assetType === 'Forex';

  return (
    <div className={`watchlist ${isForex ? 'forex-theme' : ''} ${open ? '' : 'collapsed'}`}>
      <div className="watchlist-header" onClick={() => setOpen((o) => !o)}>
        <span className="watchlist-title">Volatility Watch</span>
        <span className="watchlist-toggle">{open ? '–' : '+'}</span>
      </div>
      {open && (
        <div className="watchlist-body">
          <div className="watchlist-note">Calm now &mdash; model-flagged to move (5d)</div>
          {loading && <div className="watchlist-empty">Loading&hellip;</div>}
          {!loading && items.length === 0 && <div className="watchlist-empty">No data yet</div>}
          {!loading && items.map((it, i) => (
            <div
              className="watchlist-row"
              key={it.node}
              onClick={() => setSelectedTickers && setSelectedTickers([it.node])}
              title={`recent vol ${it.recent_vol ?? 'n/a'} → risk score ${Math.round(it.score * 100)}/100`}
            >
              <span className="watchlist-rank">{i + 1}</span>
              <span className="watchlist-ticker">{it.node}</span>
              <span className="watchlist-bar">
                <span className="watchlist-fill" style={{ width: `${Math.round(it.score * 100)}%` }} />
              </span>
              <span className="watchlist-score">{Math.round(it.score * 100)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default WatchList;
